
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { IApplicationState } from "@/store/applications/types";
import { email } from "@/validators";
import { requiredIf } from "vuelidate/lib/validators";
import api from "@/api/signup/api";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  data() {
    return {};
  },
  watch: {
    "loyaltyType": "setValidity",
    "$v.$invalid": "setValidity"
  },
  computed: {
    offerOrPromo(): string {
      const offer =
        store.state.standardOffer && store.state.standardOffer.offer.name;
      const promo =
        store.state.application.applicationData &&
        store.state.application.applicationData.loyaltyDetails &&
        store.state.application.applicationData.loyaltyDetails.promoCode;

      return promo || offer || "";
    },
    loyaltyType: {
      get(): string {
        const type =
          store.state.application.applicationData &&
          store.state.application.applicationData.loyaltyDetails &&
          store.state.application.applicationData.loyaltyDetails.pointType;

        return type || "None";
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_LOYALTY_TYPE),
          value
        );
      }
    },
    flyBuysNumber: {
      get(): string {
        return (
          (store.state.application.applicationData &&
            store.state.application.applicationData.loyaltyDetails &&
            (store.state.application.applicationData.loyaltyDetails
              .flyBuysNumber as any)) ||
          ""
        );
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_FLY_BUYS_NUMBER),
          value
        );
      }
    },
    airpointsNumber: {
      get(): string {
        return (
          (store.state.application.applicationData &&
            store.state.application.applicationData.loyaltyDetails &&
            (store.state.application.applicationData.loyaltyDetails
              .airPointsNumber as any)) ||
          ""
        );
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_AIRPOINTS_NUMBER),
          value
        );
      }
    },
    airpointsFirstName: {
      get(): string {
        return (
          (store.state.application.applicationData &&
            store.state.application.applicationData.loyaltyDetails &&
            store.state.application.applicationData.loyaltyDetails
              .airPointsFirstName) ||
          ""
        );
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_AIRPOINTS_FIRST_NAME),
          value
        );
      }
    },
    airpointsLastName: {
      get(): string {
        return (
          (store.state.application.applicationData &&
            store.state.application.applicationData.loyaltyDetails &&
            store.state.application.applicationData.loyaltyDetails
              .airPointsLastName) ||
          ""
        );
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_AIRPOINTS_LAST_NAME),
          value
        );
      }
    },
    creditLimit(): number | null | undefined {
      const creditLimit =
        store.state.application.applicationData &&
        store.state.application.applicationData.creditLimit;

      return creditLimit;
    },
    ...mapState({
      spendingEstimate: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.fuelAmount
    }),
    ...mapGetters([APPLICATION.GETTERS.IS_EDITABLE])
  },
  methods: {
    setValidity() {
      this.$emit("isvalid", "loyalty", !(this as any).$v.$invalid);
    },
    onLoyaltyTypeChange(type: any) {
      this.$store.commit(
        APPLICATION.NS(APPLICATION.MUTATIONS.SET_FLY_BUYS_NUMBER),
        ""
      );
      this.$store.commit(
        APPLICATION.NS(APPLICATION.MUTATIONS.SET_AIRPOINTS_NUMBER),
        ""
      );
      this.$store.commit(
        APPLICATION.NS(APPLICATION.MUTATIONS.SET_AIRPOINTS_FIRST_NAME),
        ""
      );
      this.$store.commit(
        APPLICATION.NS(APPLICATION.MUTATIONS.SET_AIRPOINTS_LAST_NAME),
        ""
      );
      this.setValidity();
    }
  },
  validations: {
    flyBuysNumber: {
      required: requiredIf(vm => vm.loyaltyType === "FlyBuys" && vm.isEditable),
      async isValid(value: any, vm: any) {
        if (!vm.flyBuysNumber) {
          return true;
        }

        try {
          await api.validateFlyBuys(vm.flyBuysNumber);
          vm.$v.flyBuysNumber.$touch();
        } catch (error: any) {
          return false;
        }
        return true;
      }
    },
    airpointsNumber: {
      required: requiredIf(
        vm => vm.loyaltyType === "AirPoints" && vm.isEditable
      )
    },
    airpointsFirstName: {
      required: requiredIf(
        vm => vm.loyaltyType === "AirPoints" && vm.isEditable
      )
    },
    airpointsLastName: {
      required: requiredIf(
        vm => vm.loyaltyType === "AirPoints" && vm.isEditable
      )
    },
    airpointsValid: {
      async isValid(value: any, vm: any) {
        if (vm.loyaltyType !== "AirPoints") {
          return true;
        }

        try {
          const airpoints = await api.validateAirpoints(
            vm.airpointsNumber,
            vm.airpointsFirstName,
            vm.airpointsLastName
          );
          if (airpoints && airpoints.data && airpoints.data.customerId) {
            return true;
          } else {
            return false;
          }
        } catch (error: any) {
          return false;
        }
      }
    }
  }
});
